import React from 'react';

import { formatActivityDateTime, orgRoleLabel } from './organisationUserFormat';

/**
 * One line of text per entry type. An entry with no actor recorded reads
 * without "by".
 */
function entryText({ type, actor, properties }) {
    const by = actor?.name;
    const project = properties?.event_name;

    switch (type) {
        case 'invite_sent':
            return by ? $t('Invite sent by {{name}}', { name: by }) : $t('Invite sent');
        case 'invite_resent':
            return by ? $t('Invite resent by {{name}}', { name: by }) : $t('Invite resent');
        case 'invite_accepted':
            return $t('Invite accepted');
        case 'deactivated':
            return by ? $t('Deactivated by {{name}}', { name: by }) : $t('Deactivated');
        case 'reactivated':
            return by ? $t('Reactivated by {{name}}', { name: by }) : $t('Reactivated');
        case 'mfa_reset':
            return by ? $t('MFA reset by {{name}}', { name: by }) : $t('MFA reset');
        case 'org_role_changed':
            return $t('Organisation role changed from {{from}} to {{to}}', { from: orgRoleLabel(properties?.from), to: orgRoleLabel(properties?.to) });
        case 'project_user_added':
            return properties?.role ? $t('Added to {{project}} as {{role}}', { project, role: $t(properties.role) }) : $t('Added to {{project}}', { project });
        case 'project_user_removed':
            return by ? $t('Removed from {{project}} by {{name}}', { project, name: by }) : $t('Removed from {{project}}', { project });
        case 'project_user_removal_blocked':
            return $t('Removal from {{project}} blocked: approver on approval rules', { project });
        case 'project_role_changed':
            return $t('Project role on {{project}} changed from {{from}} to {{to}}', {
                project,
                from: properties?.from ? $t(properties.from) : $t('no role'),
                to: $t(properties?.to ?? ''),
            });
        case 'user_added':
            return by ? $t('User added by {{name}}', { name: by }) : $t('User added');
        default:
            return type;
    }
}

export default function OrganisationUserTimeline({ entries }) {
    return (
        <section className="tw-space-y-3">
            <h3 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-charcoal">{$t('Activity')}</h3>

            {entries.length === 0 ? (
                <p className="tw-mb-0 tw-text-sm tw-text-charcoal-50">{$t('No activity recorded yet.')}</p>
            ) : (
                <ol className="tw-mb-0 tw-ms-1.5 tw-list-none tw-border-s-2 tw-border-charcoal-15 tw-ps-0">
                    {entries.map((entry, index) => (
                        <li key={`${entry.type}-${entry.occurred_at}-${index}`} className="tw-relative tw-pb-3 tw-ps-4">
                            <span className="tw-absolute -tw-start-[7px] tw-top-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-blue" aria-hidden="true" />
                            <div className="tw-text-0.5sm tw-text-charcoal">{entryText(entry)}</div>
                            <div className="tw-text-xs tw-text-charcoal-50">{formatActivityDateTime(entry.occurred_at)}</div>
                        </li>
                    ))}
                </ol>
            )}
        </section>
    );
}
